<template>
  <span class="cd-logo">cargo<span class="cd-logo__red-square">▄</span>direct</span>
</template>

<script>
export default {
  name: 'CdLogo',
}
</script>
